/* fp-instafeed-drawer.js
   Moved out of snippets/fp-instafeed-drawer.liquid (audit: inline JS -> asset).
   Loaded with a normal (non-deferred) <script> at the same place, so it still runs
   in the same order as before: reload guard first, then the Instafeed handlers. */
/* Global AJAX add-to-cart lives in assets/product-atc.js (loaded in <head> of theme.liquid).
   The old duplicate copy that was here never ran, because product-atc.js sets
   window.__productAtcInit first. Do not paste it back. */

/**
 * Reload guard: some apps (EG Auto Add to Cart / Easy Gift, cdn.506.io/eg)
 * call location.reload() right after a cart change. Within a few seconds of a
 * cart add/change we cancel that script reload and refresh the cart drawer
 * instead (Chrome / Edge / browsers with the Navigation API).
 * A reload the customer starts himself (browser button, F5) is never blocked.
 */
(function () {
  if (window.__fpReloadGuard) return;
  window.__fpReloadGuard = true;

  var WINDOW_MS = 10000;
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?/;
  var last = 0;
  function mark(url) { if (CART_RE.test(String(url || ''))) last = Date.now(); }

  /* Every cart request, whoever makes it (theme, bundle, app) */
  try {
    new PerformanceObserver(function (list) {
      list.getEntries().forEach(function (en) { mark(en.name); });
    }).observe({ type: 'resource', buffered: false });
  } catch (e) {}
  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function (input) {
      mark(typeof input === 'string' ? input : (input && input.url));
      return _fetch.apply(this, arguments);
    };
  }
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) { mark(u); return _open.apply(this, arguments); };

  function refreshDrawer() {
    var route = (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart';
    (_fetch || window.fetch).call(window, route + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
      })
      .catch(function () {});
  }

  if (window.navigation && typeof window.navigation.addEventListener === 'function') {
    window.navigation.addEventListener('navigate', function (e) {
      if (e.navigationType !== 'reload') return;
      if (e.userInitiated || !e.cancelable) return;
      if (Date.now() - last > WINDOW_MS) return;
      e.preventDefault();
      console.warn('[product-atc] Blocked a script page reload right after a cart change; cart drawer refreshed instead.');
      refreshDrawer();
    });
  }
})();


/**
 * Instafeed (Instagram feed app) ADD TO CART -> our own clean add + Pipeline cart drawer.
 * Why: the EG app ("BuyNowInterceptor") treats the Instafeed "tagged-buy-button" as a
 * Buy Now button: it EMPTIES the cart, adds the item and changes the cart. So we take
 * the click first (window capture, before any app), stop it, and add the variant
 * ourselves exactly like the theme does (/cart/add.js), then open the drawer.
 * Sold out buttons are blocked by CSS (pointer-events: none) and never reach here.
 */
(function () {
  if (window.__fpInstafeedDrawer) return;
  window.__fpInstafeedDrawer = true;

  var BTN = '.instafeed-modals-wrapper a[onclick*="addToCart("], .instafeed-lightbox a[onclick*="addToCart("]';
  var busy = false;

  function route() {
    return (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart';
  }
  function getCart() {
    return fetch(route() + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); });
  }
  function addVariant(id) {
    return fetch(route() + '/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok || (d && d.status >= 400)) throw new Error((d && (d.description || d.message)) || 'Could not add to cart');
        return d;
      });
    });
  }

  /* Some apps send the theme an OLD cart right after; re-sync with a fresh one */
  function resync() {
    getCart().then(function (cart) {
      document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
      document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
    }).catch(function () {});
  }
  function openDrawer(cart) {
    document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
    var d = document.querySelector('[data-drawer="drawer-cart"]');
    if (!d) return;
    d.dispatchEvent(new CustomEvent('theme:drawer:reload', { bubbles: false }));
    setTimeout(function () { d.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false })); }, 300);
    setTimeout(resync, 900);
    setTimeout(resync, 2200);
  }

  function findLink(target) { return target && target.closest ? target.closest(BTN) : null; }
  function variantOf(link) {
    var m = (link.getAttribute('onclick') || '').match(/addToCart\(\s*this\s*,\s*["']?(\d+)/);
    return m ? Number(m[1]) : null;
  }
  function setLoading(link, on) {
    var b = link.querySelector('.tagged-buy-button') || link;
    b.style.opacity = on ? '0.6' : '';
    link.style.pointerEvents = on ? 'none' : '';
  }

  /* Hide the press from every other script (EG Buy Now interceptor etc.) */
  ['pointerdown', 'mousedown', 'touchstart', 'pointerup', 'mouseup', 'touchend'].forEach(function (type) {
    window.addEventListener(type, function (e) {
      if (findLink(e.target)) e.stopImmediatePropagation();
    }, { capture: true, passive: true });
  });

  window.addEventListener('click', function (e) {
    var link = findLink(e.target);
    if (!link) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (busy) return;
    var id = variantOf(link);
    if (!id) return;
    busy = true;
    setLoading(link, true);
    var lightbox = link.closest('.instafeed-lightbox');
    addVariant(id)
      .then(getCart)
      .then(function (cart) {
        var close = lightbox && lightbox.querySelector('.instafeed-close-button');
        if (close) close.click();
        openDrawer(cart);
      })
      .catch(function (err) {
        console.error('[instafeed add]', err);
        var msg = String(err && err.message || '');
        if (/cannot find variant|sold out|out of stock|not available|unavailable/i.test(msg)) {
          markOutOfStock(link);
        } else {
          alert(msg || 'Could not add to cart. Please try again.');
        }
      })
      .then(function () { busy = false; setLoading(link, false); if (link.classList.contains('fp-if-oos')) link.style.pointerEvents = 'none'; });
  }, true);

  /* ---------- Out of stock / "Cannot find variant": show it on the button ---------- */
  var OOS_TEXT = 'Out of stock';
  (function () {
    var st = document.createElement('style');
    st.textContent = '.fp-if-oos{pointer-events:none!important;cursor:not-allowed!important}'
      + '.fp-if-oos .tagged-buy-button{opacity:.5!important;cursor:not-allowed!important}';
    document.head.appendChild(st);
  })();

  function markOutOfStock(link) {
    link.classList.add('fp-if-oos');
    link.setAttribute('aria-disabled', 'true');
    link.setAttribute('tabindex', '-1');
    var b = link.querySelector('.tagged-buy-button');
    if (b) { b.textContent = OOS_TEXT; b.disabled = true; }
  }

  var productCache = {};
  function getProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })   /* 404 = deleted / not on Online Store */
        .catch(function () { return undefined; });               /* network error: don't block */
    }
    return productCache[handle];
  }

  function checkLink(link) {
    if (link.getAttribute('data-fp-stock')) return;
    link.setAttribute('data-fp-stock', 'checking');
    var id = variantOf(link);
    var box = link.closest('.tagged-products') || link.parentElement;
    var pLink = box && box.querySelector('a[href*="/products/"]');
    var m = pLink && (pLink.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    if (!id || !m) { link.setAttribute('data-fp-stock', 'unknown'); return; }
    getProduct(m[1]).then(function (p) {
      if (p === undefined) { link.setAttribute('data-fp-stock', 'unknown'); return; }
      var v = p && (p.variants || []).filter(function (x) { return Number(x.id) === id; })[0];
      /* v.available is true when in stock OR "Continue selling when out of stock" is on */
      if (!v || !v.available) { markOutOfStock(link); link.setAttribute('data-fp-stock', 'out'); }
      else link.setAttribute('data-fp-stock', 'ok');
    });
  }

  function scanStock() { document.querySelectorAll(BTN).forEach(checkLink); }
  function startStock() {
    scanStock();
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(scanStock, 150); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startStock);
  else startStock();

  /* Keyboard: Enter on the focused link */
  window.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var link = findLink(e.target);
    if (!link) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
  }, true);
})();

/**
 * Instafeed popup: "| 66 reviews" -> "4.9/5" (Figma 188:29352: stars, 10px gap, rating/5).
 * Rating comes from /products/<handle>?view=fp-rating (templates/product.fp-rating.liquid,
 * Judge.me / Shopify reviews metafields). Fallback: the Instafeed stars (filled = 1, half = 0.5).
 */
(function () {
  if (window.__fpInstafeedRating) return;
  window.__fpInstafeedRating = true;

  var cache = {};

  function handleFrom(a) {
    var m = a && (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function starsRating(box) {
    var full = box.querySelectorAll('.instafeed-product-reviews-star.filled').length;
    var half = box.querySelectorAll('.instafeed-product-reviews-star.half').length;
    return full || half ? full + half * 0.5 : null;
  }

  function getRating(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + handle + '?view=fp-rating', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (t) {
          var d = JSON.parse(t.trim());
          var val = parseFloat(d.rating);
          if (!(val > 0) && d.badge) {
            var m = String(d.badge).match(/data-average-rating=['"]([\d.]+)['"]/);
            if (m) val = parseFloat(m[1]);
          }
          return val > 0 ? val : null;
        })
        .catch(function () { return null; });
    }
    return cache[handle];
  }

  function fmt(v) { return (Math.round(v * 10) / 10).toFixed(1) + '/5'; }

  function process(el) {
    if (el.getAttribute('data-fp-rating') === 'done') return;
    el.setAttribute('data-fp-rating', 'done');
    var box = el.closest('.instafeed-product-reviews') || el.parentElement;
    var link = el.closest('a[href*="/products/"]');
    var fallback = starsRating(box);
    el.style.marginLeft = '10px';
    if (fallback) el.textContent = fmt(fallback);
    var handle = handleFrom(link);
    if (!handle) return;
    getRating(handle).then(function (v) { if (v) el.textContent = fmt(v); });
  }

  function scan(rootEl) {
    (rootEl || document).querySelectorAll('.instafeed-product-reviews #instafeed-product-reviews-count, .instafeed-product-reviews [id="instafeed-product-reviews-count"]').forEach(process);
  }

  function start() {
    scan(document);
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { scan(document); }, 100);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
